export default {"src":"/_next/static/media/faceboock.1ca3b164.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};